<template>
  <main>
    <md-steppers md-active-step="apply" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="本契約の手続き"></md-step>
      <md-step id="start" md-label="ご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <!-- ローディング／エラーメッセージ -->
        <loading-spinner v-if="sending"></loading-spinner>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
              <flash-message :errors="[form.contractPayment.cardError]"
                             v-else-if="form.contractPayment.cardError"></flash-message>
            </div>
          </div>
        </md-card-content>

        <div class="md-layout">
          <div class="md-layout-item md-size-5 md-small-size-100"></div>
          <div class="md-layout-item md-size-90 md-small-size-100">
            <form @submit.prevent="submitForm" novalidate>
              <!-- 登記情報提供サービスIDを認証 -->
              <md-card-header>
                <div class="md-title">登記情報提供サービスのアカウントを認証</div>
              </md-card-header>
              <contract-form-t-service ref="contactFormTService"
                                       v-model="form.contractTService"></contract-form-t-service>

              <md-card-content v-show="!form.contractTService.activated">
                <div class="md-layout md-gutter">
                  <div class="md-layout md-layout-item md-alignment-center-left md-form-title">
                    以下の項目は登記情報提供サービスのアカウント認証後にご入力ください。
                  </div>
                </div>
              </md-card-content>

              <!-- 申込内容 -->
              <md-card-header>
                <div class="md-title">申込内容</div>
                <div class="md-corp-num">適格請求書発行事業者 登録番号：T9-0111-0104-7870</div>
              </md-card-header>
              <contract-form-apply ref="contactFormApply" v-model="form.contractApply"
                                   :activated="form.contractTService.activated"
                                   :class="{'md-card-content-disabled': !form.contractTService.activated}"
                                   @changeCorporationInfo="onChangeCorporationInfo()"
              ></contract-form-apply>

              <!-- 決済方法 -->
              <md-card-header>
                <div class="md-title">決済方法</div>
              </md-card-header>
              <contract-form-payment ref="contactFormPayment" v-model="form.contractPayment"
                                     :activated="form.contractTService.activated"
                                     :class="{'md-card-content-disabled': !form.contractTService.activated}"
                                     @changeBillMethod="onChangeBillMethod"
              ></contract-form-payment>

              <!-- 請求書の送付方法 -->
              <md-card-header>
                <div class="md-title">請求書の送付方法</div>
              </md-card-header>
              <contract-form-send ref="contactFormSend" v-model="form.contractSend"
                                  :corporation="form.contractApply.corporation"
                                  :account="form.contractApply.account"
                                  :activated="form.contractTService.activated"
                                  :class="{'md-card-content-disabled': !form.contractTService.activated}"
              ></contract-form-send>

              <!-- その他 -->
              <contract-form-etc v-model="form.contractEtc"
                                 :activated="form.contractTService.activated"
                                 :class="{'md-card-content-disabled': !form.contractTService.activated}"
              ></contract-form-etc>

              <!-- 利用規約 -->
              <contract-form-term ref="contactFormTerm" v-model="form.contractTerm"
                                  :activated="form.contractTService.activated"
                                  :class="{'md-card-content-disabled': !form.contractTService.activated}"
              ></contract-form-term>

              <md-card-actions>
                <div class="md-layout md-alignment-top-center">
                  <md-button type="submit" class="md-button md-primary md-raised"
                             :disabled="!verifyEmail || !form.contractTService.activated || sending || isCardAuthenticating">
                    <md-icon>save</md-icon>
                    <span>確認画面へ</span>
                  </md-button>
                </div>
              </md-card-actions>
            </form>
          </div>
        </div>

        <credit-card3ds-modal
            :isOpen="isOpenCardAuthModal"
            :creditCard3dsUrl="creditCard3dsUrl"
            @close="handleCloseCardAuthModal"
        />
      </md-card>
    </div>
  </main>
</template>

<script>
import CommonMixin              from '../../mixins/commonMixin';
import FlashMessage             from '../../components/FlashMessage';
import LoadingSpinner           from '../../components/LoadingSpinner';
import LoadingSpinnerOverlay    from '../../components/LoadingSpinnerOverlay';
import ActivationModal          from '../../components/ActivationModal';
import ContractFormTService     from "../../components/contract/ContractFormTService";
import ContractFormApply        from "../../components/contract/ContractFormApply";
import ContractFormPayment      from "../../components/contract/ContractFormPayment";
import ContractFormSend         from "../../components/contract/ContractFormSend";
import ContractFormEtc          from "../../components/contract/ContractFormEtc";
import ContractFormTerm         from "../../components/contract/ContractFormTerm";
import {validationMixin}        from 'vuelidate'
import Common                   from "../../modules/common";
import {mapActions, mapGetters} from "vuex";
import moment                   from "moment";
import ContractFormMixin        from "../../mixins/contractFormMixin";
import GMO                      from "../../modules/gmo";
import {apiClient, apiList}     from "../../modules/apiClient";
import CreditCard3dsModal       from "../../components/CreditCard3dsModal.vue";

export default {
  name      : "ContractApply",
  components: {
    CreditCard3dsModal,
    LoadingSpinnerOverlay,
    LoadingSpinner,
    FlashMessage,
    ActivationModal,
    ContractFormTService,
    ContractFormApply,
    ContractFormPayment,
    ContractFormSend,
    ContractFormEtc,
    ContractFormTerm
  },
  mixins    : [CommonMixin, validationMixin, ContractFormMixin],
  data      : () => ({
    email      : null,
    verify     : false,
    verifyEmail: false,
    form       : {
      contractTService: {
        t_service_id: null,
        activated   : false,
      },
      contractApply   : {
        corporation: {
          name         : null,
          branch_name  : null,
          postal       : null,
          pref         : null,
          city         : null,
          street_name  : null,
          street_number: null,
        },
        account    : {
          name_last : '',
          name_first: '',
          email     : null,
          tel       : null,
        },
      },
      contractPayment : {
        bill_method     : Common.billingMethodCreditCard,
        cardToken       : null,
        cardNumber      : null,
        cardExpireMonth : null,
        cardExpireYear  : moment().year(),
        cardHolder      : null,
        cardSecurityCode: null,
        cardError       : null,
      },
      contractSend    : {
        bill_via         : Common.billingViaEmail,
        name1            : null,
        name2            : null,
        name3            : null,
        postal           : null,
        email            : null,
        additionalAddresses: [],
        pref             : null,
        city             : null,
        street_name      : null,
        street_number    : null,
        etc              : null,
        isSameCorporation: false
      },
      contractEtc     : {
        contract: {
          reason: Common.contractReason[0],
        },
      },
      contractTerm    : {
        isReadTerms: false,
        apply      : false,
      },
    },
    isCardAuthenticating: false, // 本人認証中かどうか
    pendingCardToken    : null,  // 本人認証前のカードトークン
    enrollCardToken     : null,  // 登録用カードトークン
    creditCard3dsUrl    : null,  // 本人認証用のURL
    authorizedCardTokens: {},    // 本人認証済のカードトークン
  }),
  validations() {
  },
  created() {
    window.addEventListener('message', (event) => {
      // iframe（本人認証画面）からのメッセージを受信
      if (event.data?.type === '3ds2.0Completed' && event.data.result) {
        this.creditCard3dsUrl = null;
        if (['Y', 'A'].includes(event.data.result)) {
          // 本人認証成功
          this.form.contractPayment.cardToken               = this.pendingCardToken;
          this.authorizedCardTokens[this.creditCardObjHash] = this.form.contractPayment.cardToken;
          this.pendingCardToken                             = null;
          this.enrollCardToken                              = null;
          this.saveFormData(Object.assign({}, this.form));
          this.$router.push({name: 'ContractPreview'}).then();
        } else if (['N', 'U', 'R'].includes(event.data.result)) {
          // 本人認証失敗
          this.validateResponse               = [{
            target : 'card_token',
            message: Common.messages.paymentMethod.authFailed,
          }];
          this.form.contractPayment.cardError = Common.messages.paymentMethod.authFailed;
        } else {
          // 本人認証エラー
          this.validateResponse               = [{
            target : 'card_token',
            message: Common.messages.paymentMethod.authError,
          }];
          this.form.contractPayment.cardError = Common.messages.paymentMethod.authError;
        }
        this.isCardAuthenticating = false;
      }
    })
  },
  mounted() {
    this.scrollToTop();
    this.verifyEmail = false;
    this.email       = localStorage.getItem(Common.localStorageKeys.contract.email);
    this.verify      = localStorage.getItem(Common.localStorageKeys.contract.verify);
    if (this.email && this.verify) {
      localStorage.removeItem(Common.localStorageKeys.contract.verify);
      this.form.contractApply.account.email = this.email;
      this.verifyEmail                      = true;
      // 確認画面から戻ってきたとき
      if (this.formData) {
        setTimeout(() => {
          this.form = Object.assign({}, this.formData);
          if (this.formData?.contractPayment?.cardToken) {
            this.authorizedCardTokens[this.creditCardObjHash] = this.formData.contractPayment.cardToken;
          }
        }, 100)
      }
      return;
    }
    this.saveErrorMessages([Common.messages.contract.codeInvalid]);
  },
  methods : {
    ...mapActions('contractForm', [
      'saveFormData',
    ]),
    async submitForm() {
      await this.$refs.contactFormPayment.validate()
      this.$refs.contactFormTService.validate()
      this.$refs.contactFormApply.validate()
      this.$refs.contactFormSend.validate()
      this.$refs.contactFormTerm.validate()
      if (
          this.$refs.contactFormTService.validated &&
          this.$refs.contactFormApply.validated &&
          this.$refs.contactFormPayment.validated &&
          this.$refs.contactFormSend.validated &&
          this.$refs.contactFormTerm.validated
      ) {
        if (this.form.contractPayment.bill_method === Common.billingMethodCreditCard) {
          await this.startCreditCard3ds();
        } else {
          this.saveFormData(Object.assign({}, this.form));
          return this.$router.push({name: 'ContractPreview'}).then();
        }
      }
    },
    onChangeCorporationInfo() {
      this.$refs.contactFormSend.copyCorporationInformation();
    },
    onChangeBillMethod(billMethod) {
      this.$refs.contactFormSend.changeBillMethod(billMethod);
    },
    /**
     * クレカの本人認証を開始する
     * @returns {Promise<void>}
     */
    async startCreditCard3ds() {
      if (this.isCardAuthenticating) {
        return;
      }
      this.isCardAuthenticating = true;

      let authorizedCardToken = this.authorizedCardTokens[this.creditCardObjHash];

      if (authorizedCardToken) {
        this.form.contractPayment.cardToken = authorizedCardToken;
        this.isCardAuthenticating           = false;
        this.saveFormData(Object.assign({}, this.form));
        return this.$router.push({name: 'ContractPreview'}).then();
      }

      try {
        const response        = await GMO.getToken(this.creditCardObj, 2)
        this.pendingCardToken = response.tokenObject.token[0];
        this.enrollCardToken  = response.tokenObject.token[1];
        console.debug(`保留中のカードトークン: ${this.pendingCardToken}`);
      } catch {
        this.validateResponse               = [{
          target : 'card_token',
          message: Common.messages.paymentMethod.cardNotValid,
        }];
        this.form.contractPayment.cardError = Common.messages.paymentMethod.cardNotValid;
        this.isCardAuthenticating           = false;
        return;
      }

      // ** 本人認証プロセスの開始 **

      const user = Common.getCurrentUserInfo();

      // 項目はGMO-PGのドキュメントを参照
      // https://gmopg_docs:PF%cwa$GmCC@docs.mul-pay.jp/payment/credit/api3ds2#exectran
      const card3dsParams = {
        Tds2ThreeDSReqAuthMethod: '02',
        Tds2Email               : user.email,
        Tds2BillAddrCountry     : '392',
      };
      // 郵便番号
      if (this.form.contractApply.corporation.postal) {
        card3dsParams.Tds2BillAddrPostCode = this.form.contractApply.corporation.postal;
      }
      // 都道府県番号
      if (this.form.contractApply.corporation.pref) {
        card3dsParams.Tds2BillAddrState = Common.prefNameToCode(this.form.contractApply.corporation.pref);
      }
      // 市区町村
      if (this.form.contractApply.corporation.city) {
        card3dsParams.Tds2BillAddrCity = this.form.contractApply.corporation.city;
      }
      // 町域・丁目番地
      if (this.form.contractApply.corporation.street_name) {
        card3dsParams.Tds2BillAddrLine1 = this.form.contractApply.corporation.street_name + (this.form.contractApply.corporation.street_number || '');
      }
      // 建物・号室
      if (this.form.contractApply.corporation.etc) {
        card3dsParams.Tds2BillAddrLine2 = this.form.contractApply.corporation.etc;
      }

      // APIリクエスト
      const {data, status} = await apiClient.post(apiList.payment.card3ds.start, {
        card_token       : this.pendingCardToken,
        enroll_card_token: this.enrollCardToken,
        card_3ds_params  : card3dsParams,
      })

      // HTTP 200 以外の場合、エラー
      if (status !== 200) {
        this.validateResponse               = [{
          target : 'card_token',
          message: Common.messages.paymentMethod.authError,
        }];
        this.form.contractPayment.cardError = Common.messages.paymentMethod.authError;
        this.isCardAuthenticating           = false;
        return;
      }

      // 認証用URLが設定されている場合、本人認証画面（CreditCard3dsModal）を開く
      if (data.auth_url) {
        this.creditCard3dsUrl = data.auth_url;
        return;
      }

      if (data.errors) {
        // ** 通常オーソリ失敗 **
        this.validateResponse               = data.errors;
        this.form.contractPayment.cardError = data.errors.find(e => e.target === 'card_token')?.message || '';
      } else {
        // ** 通常オーソリ成功 **
        console.debug('3DS2.0未対応のクレジットカードです');
        this.form.contractPayment.cardToken               = this.pendingCardToken;
        this.authorizedCardTokens[this.creditCardObjHash] = this.form.contractPayment.cardToken;
        this.pendingCardToken                             = null;
        this.enrollCardToken                              = null;
        this.saveFormData(Object.assign({}, this.form));
        this.$router.push({name: 'ContractPreview'}).then();
      }
      this.isCardAuthenticating = false;
    },
    /**
     * クレカ本人認証モーダルが閉じられたときの処理
     */
    handleCloseCardAuthModal() {
      this.creditCard3dsUrl     = null;
      this.isCardAuthenticating = false;
    },
  },
  computed: {
    ...mapGetters('contractForm', {
      formData: 'formData',
    }),
    isOpenCardAuthModal() {
      return this.creditCard3dsUrl !== null;
    },
    creditCardObj() {
      return {
        cardno      : this.form.contractPayment.cardNumber,
        expire      : this.form.contractPayment.cardExpireYear + this.form.contractPayment.cardExpireMonth,
        securitycode: this.form.contractPayment.cardSecurityCode,
        holdername  : this.form.contractPayment.cardHolder,
      };
    },
    creditCardObjHash() {
      return btoa(JSON.stringify(this.creditCardObj));
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 30px;
}

.mg-l-20 {
  margin-left: 20px;
}

.md-checked {
  color: #ff5252 !important;
}

.check-same-corp {
  margin-top: 16px;
}

button.check-same-corp {
  margin-left: 0;
  margin-top: 0;
}

.md-card-actions {
  .md-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.md-card-content-disabled {
  background-color: #f8f8f8;
}

@media screen and (max-width: 1024px) {
  .check-same-corp {
    i {
      display: none;
    }
  }
}

.md-corp-num {
  position: absolute;
  right: 0;
  padding-right: 60px;
  margin-top: -10px;
}
</style>
